<template>
  <div class="mt-8">
    <lazy-home-page-custom-component-our-mission
      v-if="component.customComponent.componentKey === 'ourMission'"
      :component="component"
    />

    <lazy-home-page-custom-component-footer
      v-else-if="component.customComponent.componentKey === 'footer'"
      :component="component"
    />

    <!-- TODO: Delete after migrate to the generic banner component -->
    <!-- TODO: Remove order-url from StrapiHomePageComponents ans StrapiProductComponents -->
    <lazy-landing-page-banner
      v-else-if="component.customComponent.componentKey != null"
      :order-url="orderUrl"
      :component="component"
      class="max-w-screen-xl mx-auto px-4"
    />
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

defineProps({
  orderUrl: {
    type: String,
    required: true,
  },
  component: {
    type: Object as PropType<StrapiCustomComponent>,
    required: true,
  },
});
</script>
